var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"left-logo"},[_c('span',[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("./../../assets/logo-old.png")},on:{"click":_vm.jumpToIndex}})])]),_c('div',{staticClass:"right-menu"})])
}
var staticRenderFns = []

export { render, staticRenderFns }